<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="searchForm" :inline="true" size="mini" ref="searchForm" label-width="100px">
          <el-form-item label="京东SKU编码" prop="skuList">
            <el-input v-model="searchForm.skuList" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="京东SKU名称" prop="skuName">
            <el-input v-model.trim="searchForm.skuName" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="限售分类" prop="classificationName">
            <el-select v-model="searchForm.classificationName" clearable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option :label="item" :value="item" v-for="(item, index) in classificationNameList" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="small" @click="isShowAllocation = true">限售分类配置</el-button>
        <el-button type="primary" size="small" @click="importExcel">导入</el-button>
        <el-button type="primary" size="small" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        :data="tableData.records"
        ref="tableRef"
        border
        :height="maxTableHeight"
        :cell-style="{ textAlign: 'left' }"
        :header-cell-style="{ textAlign: 'left' }"
        v-loading="loading"
      >
        <el-table-column label="京东SKU编码" prop="sku" min-width="120"></el-table-column>
        <el-table-column label="京东SKU名称" prop="skuName" min-width="350px" show-overflow-tooltip></el-table-column>
        <el-table-column label="限售分类" prop="classificationName" min-width="100"></el-table-column>
        <el-table-column label="更新人" prop="updatedBy" min-width="100"></el-table-column>
        <el-table-column label="更新日期" prop="updatedDate" min-width="160"></el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" style="color: red" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
            background
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>
    <!-- 配置 -->
    <allocation-dialog :visible.sync="isShowAllocation" v-if="isShowAllocation" @success="onSearch" />
    <q-dialog
      :visible="dialogVisible"
      title="编辑"
      width="500px"
      :innerScroll="false"
      :loading="dialogLoading"
      @close="closeDialog"
      @cancel="closeDialog"
      @confirm="submitDialog"
    >
      <el-form ref="dialogForm" :model="editForm" :rules="editRules" label-width="100px" size="mini">
        <el-form-item label="京东SKU编码">
          <el-input v-model="editForm.sku" disabled></el-input>
        </el-form-item>
        <el-form-item label="限售分类" prop="classificationName">
          <el-select v-model="editForm.classificationName" placeholder="请选择" clearable>
            <el-option v-for="(item, index) in classificationNameList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </q-dialog>
    <!-- 导入 -->
    <!-- <import-excel :visible.sync="isShowImport" v-if="isShowImport" :classificationNameList="classificationNameList" @success="onSearch" /> -->
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin'
import allocationDialog from './allocationDialog'
// import importExcel from './importExcel';
export default {
  name: 'JDSku',
  mixins: [tableMixin, pagePathMixin],
  components: { allocationDialog },
  data () {
    return {
      searchForm: {
        skuList: '',
        skuName: '',
        classificationName: ''
      },
      tableHeight: 0,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0
      },
      dialogVisible: false,
      dialogLoading: false,
      editForm: {
        id: '',
        sku: '',
        classificationName: ''
      },
      editRules: {
        classificationName: [
          { required: true, message: '不能为空', trigger: 'change' }
        ]
      },
      loading: false,
      all: false,
      isShowAllocation: false,
      isShowImport: false,
      searchFormData: {},
      imgList: [],
      classificationNameList: [],
      orderDto: {},
      queryCriteria: [],
      dialogType: 1,
      timeText: {}
    }
  },
  computed: {},
  mounted () {
    this.onSearch()
    this.getConfigInfoStr()
  },
  methods: {
    onSearch () {
      this.tableData.pageNum = 1
      this.init()
    },
    async init () {
      this.loading = true
      const data = {
        filterData: {
          ...this.searchForm,
          skuList: this.searchForm.skuList ? this.searchForm.skuList.split(' ') : []
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize
      }
      this.searchFormData = data
      this.$q.dataImport
        .skuListPage({ data: data })
        .then((res) => {
          if (Number(res.code) === 200) {
            this.tableData = res.data
            // console.log(res.data.records.map(v=>v.sku).join('\n'));
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 分页器 pagesize
    handleSizeChange (val) {
      console.log(val)
      this.tableData.pageSize = val
      this.tableData.pageNum = 1
      this.init(this.searchFormData)
    },
    // 分页器 pageNum
    handleCurrentChange (val) {
      console.log(val)
      this.tableData.pageNum = val
      this.init(this.searchFormData)
    },
    // 重置
    reset () {
      this.tableData.pageNum = 1
      this.tableData.pageSize = 30
      this.$refs.searchForm.resetFields()
      this.onSearch()
    },
    getConfigInfoStr () {
      this.$q.dataImport.getConfigInfoStr().then((res) => {
        this.classificationNameList = res.data
      })
    },
    handleEdit (row) {
      this.editForm = {
        id: row.id || '',
        sku: row.sku,
        classificationName: row.classificationName || ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.dialogForm) {
          this.$refs.dialogForm.clearValidate()
        }
      })
    },
    closeDialog () {
      this.dialogVisible = false
      this.dialogLoading = false
      this.editForm = {
        id: '',
        sku: '',
        classificationName: ''
      }
    },
    submitDialog () {
      this.$refs.dialogForm.validate((valid) => {
        if (!valid) return
        this.dialogLoading = true
        this.$q.dataImport.updateJdSKU({
          params: {
            sku: this.editForm.sku,
            classificationName: this.editForm.classificationName
          }
        }).then((res) => {
          if (res.success || Number(res.code) === 200) {
            this.$message.success('编辑成功')
            this.closeDialog()
            this.init()
          } else {
            this.$message.error(res.message)
          }
        }).finally(() => {
          this.dialogLoading = false
        })
      })
    },
    async handleDelete (row) {
      const status = await this.$confirm('是否确认删除该条数据？', '提示', { type: 'warning' }).catch(() => '')
      if (status !== 'confirm') return
      this.loading = true
      this.$q.dataImport.deleteJdSKU({ params: { sku: row.sku } }).then((res) => {
        if (res.success || Number(res.code) === 200) {
          this.$message.success('删除成功')
          if (this.tableData.records.length === 1 && this.tableData.pageNum > 1) {
            this.tableData.pageNum -= 1
          }
          this.init()
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 导入
    importExcel () {
      this.openSubPage({
        // 核心语句
        path: '/JDSkuImport',
        // name: 'importexcelbyspu',   //跳转的路径
        query: {
          // 路由传参时push和query搭配使用 ，作用时传递参数
          // fileType: '18',
          fileName: '京东SKU导入.xlsx',
          appCode: 'ec-pc-new',
          reportName: 'importSkuClassification'
        }
      })
    },
    // 导出
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = {
        appCode: 'ec-pc-new',
        paramMap: {
          ...this.searchFormData.filterData
        },
        reportName: 'skuListPageExport'
      }
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！')
          loading.close()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
body {
  height: auto !important
}
.between {
  display: flex
  justify-content: space-between
  align-items: center
}

.search-box
  >>> .el-select
    width 240px !important

>>> .el-dialog .el-select
  width 100%

.panel-in-tab
  >>> .search-outer>div
    padding 0
</style>
<style lang="css">
.el-tooltip__popper {
  max-width: 40%;
}
</style>
